// extracted by mini-css-extract-plugin
module.exports = {"container":"PurchaseTokensBanner_container__cRu_h","icon":"PurchaseTokensBanner_icon__2AGdx","bannerText":"PurchaseTokensBanner_bannerText__wgyaF"};